/**
 * This is the securityquestion routes configuration.
 * Only configure routes in this file.
 * @memberOf securityquestion Module
 * @namespace securityquestion Routes
 */
import confirmTemplate from './rsa.confirm.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf securityquestion Module.securityquestion Routes
 * @ngInject
 */
var config = function ($stateProvider) {

    /* Create the securityquestion state and assign the template and controller. */
    $stateProvider
		.state('login.securityquestion.rsa.confirm', {
			url: '/confirm',
			template: confirmTemplate,
			controller: 'rsaConfirmController',
			controllerAs: 'vm'
		});
};

export default config;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/confirm/rsa.confirm.route.js